import { Box, Button, Grid, Modal, Tab, Tabs } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { FormProvider, UseFormReturn } from "react-hook-form";
import {
  RHFAutocomplete,
  RHFTextField,
} from "../../../../../RHFComponents/RHFComponents";
import MedintFormInterface from "../../../../../../services/medintInterfaces";
import { MedintDataContext } from "../../../../Context/MedintContextWrapper";
import { eqmed } from "../../../../../../networking";

const ModalRicoveri = (props: {
  open: boolean;
  methods: UseFormReturn<MedintFormInterface>;
  fetchDataMedico: () => Promise<void>;
  handleClose: () => void;
  allertMessageProps: {
    showAllert: boolean;
    setShowAllert: React.Dispatch<React.SetStateAction<boolean>>;
    setMessage: React.Dispatch<React.SetStateAction<string>>;
    setSeverity: React.Dispatch<React.SetStateAction<string>>;
    severity: string;
    message: string;
    dataToSend: any;
    submitFunction: (() => void) | null;
    setFn: React.Dispatch<React.SetStateAction<(() => void) | null>>;
}
}) => {
  const context = useContext(MedintDataContext);

  const submitFunction = async () => {    
    const tempState = props.methods.getValues(
      "medIntRicoveriInterventi.modalFormValues.state",
    );
    const tempIdEquMed = props.methods.getValues(
      "medIntRicoveriInterventi.modalFormValues.idEquMed",
    );

    try {
      const response = await eqmed({
        crud: tempState,
        prgint: tempIdEquMed ?? "",
        dati: {
          equmed: {
            MEDINT_PRGINT: context?.selectedDoctor?.pkey,
            MEDINT_CODICE: props.methods.getValues(
              "medIntRicoveriInterventi.modalFormValues.medComp",
            ),
            MANSIO_CODICE: props.methods.getValues(
              "medIntRicoveriInterventi.modalFormValues.mansCod",
            ),
            EQUMED_NORMALIZZAZIONE: "",
          },
        },
      });

      props.allertMessageProps.setMessage(response.data.messaggio);

      console.log("Risposta della send", response);

      if (response.data.esito === "OK") {
        props.allertMessageProps.setSeverity("success");
      } else if (response.data.esito === "KO") {
        props.allertMessageProps.setSeverity("warning");
      } else {
        props.allertMessageProps.setSeverity("error");
        props.allertMessageProps.setMessage(
          "Registrazione database fallita, contattare l'amministratore",
        );
      }
    } catch (error) {
      console.warn("Si è presentato un errore durante l'inserimento", error);
    } finally {
      props.allertMessageProps.setShowAllert(true);
      setTimeout(() => {
        props.handleClose();
        props.allertMessageProps.setShowAllert(false);
      }, 5000);
    }
  };

  return (
    <>
      <Modal open={props.open}>
        <FormProvider {...props.methods}>
          <Box
            sx={{
              maxHeight: "90vh",
              maxWidth: "150vh",
              width: "50%",
              overflow: "auto",
              paddingTop: 1,
              backgroundColor: "white",
              borderRadius: 2,
              boxShadow: 24,
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Tabs value={0} sx={{ paddingLeft: 2 }}>
              <Tab
                sx={{
                  fontFamily: "Montserrat",
                  fontWeight: "bold",
                  textTransform: "none",
                }}
                label="Équipe - Medico Dettaglio"
              />
            </Tabs>
            <Grid container spacing={2} padding={2}>
              <Grid item xs={12}>
                <RHFTextField
                  name="medIntRicoveriInterventi.modalFormValues.medIntCod"
                  disabled
                  control={props.methods.control}
                  label="Equipe"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <RHFAutocomplete
                  control={props.methods.control}
                  sx={{ mt: 1 }}
                  name="medIntRicoveriInterventi.modalFormValues.medComp"
                  label="Medico Componente"
                  options={context?.doctorsData ?? []}
                  keyField="id"
                  getOptionLabel={(d: any) =>
                    `${d?.["codice medico"] ?? "N/a codice"} - ${d?.cognome ?? "N/A nome"} ${d?.nome ?? "N/A cognome"}`.trim()
                  }
                  mapIn={(id, opts) =>
                    opts.find(
                      (o: any) =>
                        String(o?.["codice medico"] ?? o.pkey) === String(id),
                    ) ?? null
                  }
                  mapOut={(opt: any) =>
                    String(opt?.["codice medico"] ?? opt?.pkey ?? "") || null
                  }
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <RHFAutocomplete
                  name="medIntRicoveriInterventi.modalFormValues.mansCod"
                  control={props.methods.control}
                  fullWidth
                  label="Mansione nell'equipe"
                  options={context?.listaMansioni ?? []}
                  autoComplete
                  autoHighlight
                  getOptionLabel={(d: any) =>
                    `${d?.descrizione ?? "N/A descrizione"}`.trim()
                  }
                  mapIn={(id, opts) =>
                    opts.find(
                      (o: any) => String(o?.codice ?? o.pkey) === String(id),
                    ) ?? null
                  }
                  mapOut={(opt: any) =>
                    String(opt?.codice ?? opt?.pkey ?? "") || null
                  }
                />
              </Grid>
              <Grid item xs={12} md={12} width={"100%"}>
                <Grid
                  container
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Grid item>
                    <Button
                      variant="outlinedCustom"
                      onClick={() => {props.handleClose()}}
                    >
                      Indietro
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="containedCustom"
                      onClick={props.methods.handleSubmit(async () => {
                        await submitFunction();
                      })}
                    >
                      Conferma
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </FormProvider>
      </Modal>
    </>
  );
};

export default ModalRicoveri;
